import { PRODUCT_TYPES } from 'types';

export const PRODUCT_INFORMATION = {
  [PRODUCT_TYPES.treasury_account]: {
    title: 'Treasury | Earn up to 5.4% with U.S. Treasuries',

    details: [
      {
        title: 'Investment account in your name',
        description:
          'Account and assets held directly in your name with BNY Mellon Pershing. BNY Mellon is the world’s largest custodian with ~$47 trillion in assets',
      },
      {
        title: 'High-grade investment products',
        description:
          'Our algorithm recommends portfolios customized to your unique liquidity needs, all in a few clicks',
      },
      {
        title: 'Access your funds anytime',
        description:
          'The U.S. Treasury market is one of the most liquid financial markets in the world. Money available in less than 1 business day',
      },
    ],
  },
  [PRODUCT_TYPES.banking_account]: {
    title: 'Business Banking | Multi-entity, multi-curency accounts',

    details: [
      {
        title: 'Seamlessly manage accounts for multiple entities',
        description:
          'Open unlimited multi-currency accounts for your companies to receive payments from global customers faster‍',
      },
      {
        title: 'Real-time payments in 180+ countries',
        description: 'Pay your vendors or contractors locally across 180+ countries in over 100 currencies',
      },
      {
        title: 'Make bulk payouts, in a single click',
        description: 'Upload a CSV file, and make thousands of payments with one click',
      },
      {
        title: 'Seamless integration with your favorite accounting software',
        description:
          'Connect accounting software for all of your entities, so your books are closed faster, without any manual efforts',
      },
    ],
  },
  [PRODUCT_TYPES.cards]: null,
};
